import React from 'react';
import { Button } from '../ui/button';
import { ZoomIn, ZoomOut, Maximize2 } from 'lucide-react';
import { Slider } from '../ui/slider';

export default function ZoomControls({ zoom, onZoomIn, onZoomOut, onFitToScreen, onZoomChange }) {
  const zoomPercentage = Math.round(zoom * 100);

  return (
    <div className="absolute bottom-6 right-6 flex items-center gap-2 p-2 bg-card/95 backdrop-blur-sm border border-border rounded-2xl shadow-lg">
      <Button
        variant="ghost"
        size="sm"
        onClick={onZoomOut}
        disabled={zoom <= 0.25}
        className="rounded-xl h-9 w-9 p-0"
        title="Zoom Out (Ctrl+-)"
      >
        <ZoomOut className="w-4 h-4" />
      </Button>

      <Slider
        value={[zoom * 100]}
        onValueChange={([value]) => onZoomChange(value / 100)}
        min={25}
        max={500}
        step={25}
        className="w-32"
      />

      <div className="min-w-[60px] text-center">
        <span className="text-sm font-medium">{zoomPercentage}%</span>
      </div>

      <Button
        variant="ghost"
        size="sm"
        onClick={onZoomIn}
        disabled={zoom >= 5}
        className="rounded-xl h-9 w-9 p-0"
        title="Zoom In (Ctrl++)"
      >
        <ZoomIn className="w-4 h-4" />
      </Button>

      <div className="w-px h-6 bg-border" />

      <Button
        variant="ghost"
        size="sm"
        onClick={onFitToScreen}
        className="rounded-xl h-9 w-9 p-0"
        title="Fit to Screen (Ctrl+0)"
      >
        <Maximize2 className="w-4 h-4" />
      </Button>

      <div className="text-xs text-muted-foreground px-2">
        <kbd className="px-1.5 py-0.5 text-xs bg-muted rounded">Ctrl</kbd> +{' '}
        <kbd className="px-1.5 py-0.5 text-xs bg-muted rounded">Wheel</kbd>
      </div>
    </div>
  );
}
